<div
  class="task-item flex items-center font-medium py-1 w-full text-sm text-textoGrisOscuro px-3 gap-1 border-{{
    categoryMapper
  }} task-item__border-{{ categoryMapper }}"
  [ngClass]="{ 'task-item__border': hasBorder, 'hover-task-item cursor-pointer': hasHover }">
  <div
    class="flex items-center bodyMedium w-full my-1"
    (click)="handleClickInstrument(activity)"
    [ngClass]="{
      'opacity-50 pointer-events-none': !hasHover,
    }">
    <ng-container>
      <div class="flex items-center gap-4 pr-1" *ngIf="activity?.resourceUrl || activity?.isHidden || activity?.link">
        <svg-icon
          *ngIf="
            activity?.resourceUrl &&
            (activity?.typologyStyle === 'recurso_teorico' || activity?.typologyStyle === tipologyStyle.VIDEO_ACTIVITY)
          "
          key="play"
          class="aria-hidden"
          size="lg"></svg-icon>

        <svg-icon
          *ngIf="(activity?.resourceUrl || activity?.link) && activity?.typologyStyle !== tipologyStyle.VIDEO_ACTIVITY"
          key="download"
          class="aria-hidden mr-3"
          size="sm"></svg-icon>
      </div>

      <span>{{ activity?.title }}</span>
      <span *ngIf="activity?.solutionaryLink || activity?.solutionaryUrl" class="ml-1">({{ 'f.generic.solutionary' | translate }} )</span>

      <svg-icon
        *ngIf="activity?.isHidden || activity?.solutionaryLink || activity?.solutionaryUrl"
        key="disable-circle"
        class="aria-hidden ml-3"
        size="sm"></svg-icon>
    </ng-container>
  </div>
  <zero-exercise-status
    *ngIf="activity.completedExcercises !== undefined && activity.totalExcercises !== undefined"
    [completedExcercises]="activity.completedExcercises"
    [totalExcercises]="activity.totalExcercises"
    [isSent]="activity.isSent"></zero-exercise-status>
</div>
